<template>
    <div>
      <div class="sub-button-container">
        <button
          v-for="(item, index) in components"
          :key="index"
          :class="{ active: currentComponent === item.component }"
          @click="currentComponent = item.component"
        >
          {{ item.name }}
        </button>
      </div>
      <component :is="currentComponent"></component>
    </div>
  </template>
  
  <script>
import CatalougeCategoryManager from './CatalougeCategoryManager.vue';
import CatalougeItemManager from './CatalougeItemManager.vue';
import CatalougeView from './CatalougeView.vue';

     
  
  export default {
    data() {
      return {
        currentComponent: 'CatalougeCategoryManager', 
        components: [ 
          { name: 'Katalog Ürün Kategorileri', component: 'CatalougeCategoryManager' },
          { name: 'Katalog Ürün Girişi', component: 'CatalougeItemManager' },  
          { name: 'Katalog Görünümü', component: 'CatalougeView' },  
        ],
      };
    },
    components: {    
      CatalougeCategoryManager,
      CatalougeItemManager,
      CatalougeView

    },
  };
  </script>
    
  <style scoped> 
  </style>
    